export const LOCATIONS = 'LOCATIONS'

export const API_PATH = '/locations'
